import { useExperienceStore } from '@shared/stores/experienceStore';
import type { CompiledBannerConfig } from '@shared/types/domainConfig';
import {
  toResidentBannerRuntimeKey,
  type ResidentBannerModuleKey,
} from '@shared/lib/residentBannerLocationCodes';

function hasRenderableImages(config: CompiledBannerConfig | undefined): config is CompiledBannerConfig {
  return Array.isArray(config?.images)
    && config.images.some((image) => String(image.image_url ?? '').trim().length > 0);
}

export function useBannerLocation(bannerKey: string): CompiledBannerConfig | undefined {
  const config = useExperienceStore((state) => state.experience?.banners?.[bannerKey]);
  return hasRenderableImages(config) ? config : undefined;
}

export function useHomeBannerLocations(): {
  topBanner: CompiledBannerConfig | undefined;
  bottomBanner: CompiledBannerConfig | undefined;
} {
  const topBanner = useBannerLocation(toResidentBannerRuntimeKey('home', 'top'));
  const bottomBanner = useBannerLocation(toResidentBannerRuntimeKey('home', 'bottom'));

  return { topBanner, bottomBanner };
}

export function useResidentModuleBannerLocations(moduleKey: ResidentBannerModuleKey): {
  topBanner: CompiledBannerConfig | undefined;
  bottomBanner: CompiledBannerConfig | undefined;
} {
  const topBanner = useBannerLocation(toResidentBannerRuntimeKey(moduleKey, 'top'));
  const bottomBanner = useBannerLocation(toResidentBannerRuntimeKey(moduleKey, 'bottom'));

  return { topBanner, bottomBanner };
}

export type { ResidentBannerModuleKey };
